import React, { useContext, useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import MobileNavigationRailContext from '|/app/mobile-navigaton-rail-context';
import { Summary, Dashboard } from '|/app/services';
import NavigationRail from '|/app/steps/navigation-rail';
import CloseIcon16px from '|/icons/close16px.svg';
import theme from '../../../components/base/theme';
import { SupportContactButton } from '../../header/supportcontact';
import SupportContactMfeContext from '../../support-contact-mfe-context';

const MobilePositioning = styled.div<{ isOpen: boolean }>`
  @media(max-width: ${theme.breakpoints.sm}) {
  z-index: var(--layers-sidebars);
  width: 80%;
  background: var(--colors-neutral-white);
  position: fixed;
  top: 0;
  right: 0;
  height: 100dvh;
  overflow-y: auto;
  ${props =>
    props.isOpen
      ? css`
          visibility: visible;
        `
      : css`
          visibility: collapse;
        `}
  transform: ${props => (props.isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-out;
  padding-bottom: env(safe-area-inset-bottom);
  }
`;

const TopSection = styled.div`
  height: 48px;
  border-bottom: 1px solid var(--colors-neutral-gray-2);
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: ${theme.breakpoints.sm}) {
    display: none;
  }
`;

const CloseIcon = styled(CloseIcon16px)`
  margin-right: 16px;
`;

const SupportContactWrapper = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  margin-left: 16px;
`;

const Overlay = styled.div<{ $show: boolean }>`
  @media (min-width: ${theme.breakpoints.sm}) {
    display: none;
  }

  z-index: var(--layers-sidebars);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0 0 0 / 50%);
  ${props =>
    props.$show
      ? css`
          visibility: visible;
        `
      : css`
          visibility: hidden;
        `}
`;

const defaultProps = {
  dashboard: null as null | Dashboard,
  summary: null as null | Summary
};

const MobileNavigationRail = ({ dashboard, summary } = defaultProps) => {
  const { showMobileNavigationRail, setShowMobileNavigationRail } = useContext(
    MobileNavigationRailContext
  );
  const { setIsSupportMfeOpen } = useContext(SupportContactMfeContext);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showMobileNavigationRail) {
      document.body.className = `${document.body.className} navrail-scroll-lock`;
    } else {
      document.body.className = document.body.className.replace(
        'navrail-scroll-lock',
        ''
      );
    }
  }, [showMobileNavigationRail]);

  return (
    <>
      <Overlay
        $show={showMobileNavigationRail}
        onClick={() => {
          setShowMobileNavigationRail(false);
          if (menuRef.current) {
            menuRef.current.scrollIntoView();
          }
        }}
        data-analytics-id="pp_navrail_overlay"
      />
      <MobilePositioning isOpen={showMobileNavigationRail}>
        <TopSection ref={menuRef}>
          <SupportContactWrapper>
            <SupportContactButton setIsOpen={setIsSupportMfeOpen} />
          </SupportContactWrapper>
          <CloseIcon
            onClick={() => {
              setShowMobileNavigationRail(false);
              if (menuRef.current) {
                menuRef.current.scrollIntoView();
              }
            }}
            data-analytics-id="pp_navrail_close"
          />
        </TopSection>
        <NavigationRail
          dashboard={dashboard}
          summary={summary}
          onNavigate={() => setShowMobileNavigationRail(false)}
        />
      </MobilePositioning>
    </>
  );
};

export default MobileNavigationRail;
